import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { EntryPageResource } from "core/stages-client";

type EntryPageTab = stages.entrypage.EntryPageTab;

@Injectable({ providedIn: "root" })
export class EntryPageTabsResolver implements Resolve<EntryPageTab[]> {
	private entryPageResource = inject(EntryPageResource);

	async resolve(_route: ActivatedRouteSnapshot): Promise<EntryPageTab[]> {
		return this.entryPageResource.getTabs();
	}
}
